import React, { useRef } from 'react';
import { useEnrollmentFormData } from './StudentEnrollmentFormContext';
import { createGlobalStyle } from 'styled-components';
import { useParams } from 'react-router-dom';

const PrintHideStyle = createGlobalStyle`
  @media print {
    .print-hide {
      display: none !important;
    }
    
    @page {
      margin: 0;
      size: A4;
    }
    
    body {
      -webkit-print-color-adjust: exact;
      print-color-adjust: exact;
    }
  }
`;

const ConsentReleaseInfoForm = () => {
  const docRef = useRef();
  const { data: student, loading, error } = useEnrollmentFormData();

  const handleDownload = () => {
    window.print();
  };

  if (loading) {
    return <div style={{ textAlign: 'center', marginTop: 40 }}>Loading student information...</div>;
  }
  if (error || !student) {
    return <div style={{ textAlign: 'center', marginTop: 40, color: 'red' }}>Error loading student information.</div>;
  }
  const name = `${student.firstName || ''} ${student.lastName || ''}`.trim();
  const date = student.bc_parent_signature_date ? new Date(student.bc_parent_signature_date).toLocaleDateString() : '';
  const signature = student.student_ack_signature_data || '';

  return (
    <div style={{ maxWidth: 700, margin: '40px auto', background: '#fff', padding: 32, fontFamily: 'sans-serif' }}>
      <PrintHideStyle />
      <div ref={docRef}>
        <div style={{ textAlign: 'center', marginBottom: 32, marginTop: 32 }}>
          <img src={process.env.PUBLIC_URL + '/forms_logo.png'} alt="CCLC Logo" style={{ height: 60, marginRight: 16 }} />
          <div>
            <div style={{ fontWeight: 700, fontSize: 18, marginBottom: 8, marginTop: 8 }}>Chicago Community Learning Center</div>
            <div style={{ fontSize: 13 }}>
              Chicago Campus: 840 W. Irving Park Road, suite 203, Illinois 60613 Office: (773) 506-1503<br />
              Evergreen Campus: 9730 S. Western Ave, suite 502, Evergreen Park Illinois 60805<br />
              www.cclctraining.org
            </div>
          </div>
        </div>
        <div style={{ textAlign: 'center', fontWeight: 700, fontSize: 18, textDecoration: 'underline', marginBottom: 52, marginTop: 32, fontFamily: 'sans-serif' }}>
          CONSENT TO TEST AND RELEASE INFORMATION
        </div>
        <div style={{ fontSize: 15, marginBottom: 32, marginTop: 32, fontFamily: 'sans-serif' }}>
          I grant the Chicago Community Learning Center, Chicago Campus Permission to:
          <ul style={{ marginTop: 8, marginBottom: 8, fontFamily: 'sans-serif' }}>
            <li>Administer, score, and interpret assessment test of interest, and abilities related to my employment, training, and services needed.</li>
            <li>Use the results of the test given to me to make decisions about training programs, referrals, and other related services.</li>
            <li>Obtain information from and/or release information to an of the following:
              <div style={{ marginLeft: 24, marginTop: 24, fontFamily: 'sans-serif' }}>
                Agencies<br />
                Employers<br />
                School/Colleges<br />
                Institutions/Business UI Wages<br />
                Transmit file to TARA
              </div>
            </li>
          </ul>
        </div>
        <div style={{ fontSize: 14, marginBottom: 32, marginTop: 32, fontFamily: 'sans-serif' }}>
          <p>This information may be used to assist my eligibility determination, my progress in WIA funded activities, and/or provided verification of employment.</p>
        
        </div>
        <div style={{ fontSize: 14, marginBottom: 52, marginTop: 32, fontFamily: 'sans-serif' }}>
          <u>I have read and fully understand the above information. Further, I also understand that attendance at the initial assessment does not guarantee participation in WIA.</u>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 32, marginTop: 32, fontFamily: 'sans-serif' }}>
          <span style={{ minWidth: 180 }}>Student Name (print please):</span>
          <span style={{ borderBottom: '1px solid #333', minWidth: 180, display: 'inline-block', marginRight: 16, padding: '0 4px' }}>{name}</span>
          <span style={{ minWidth: 40 }}>Date:</span>
          <span style={{ borderBottom: '1px solid #333', minWidth: 100, display: 'inline-block', padding: '0 4px' }}>{date}</span>
        </div>
        <div style={{ display: 'flex', alignItems: 'center', marginBottom: 32, marginTop: 32 , fontFamily: 'sans-serif'}}>
          <span>Student Signature:</span>
          <span style={{ borderBottom: '1px solid #333', minWidth: 250, display: 'inline-block', marginRight: 17, padding: '0 4px', height: 40 }}>
            {(() => {
              const sigData = signature;
              
              // Check if it's a valid data URL (must have content after data:)
              if (typeof sigData === 'string' && sigData.startsWith('data:') && sigData.length > 6) {
                return (
                  <img 
                    src={sigData} 
                    alt="Student Signature" 
                    style={{ maxHeight: 40, verticalAlign: 'middle' }} 
                  />
                );
              }
              
              // Check if it's SVG markup
              if (typeof sigData === 'string' && sigData.trim().startsWith('<svg')) {
                return (
                  <div 
                    dangerouslySetInnerHTML={{ __html: sigData }}
                    style={{ maxHeight: 40 }}
                  />
                );
              }
              
              // Check if it's a base64 string (without data URL prefix)
              if (typeof sigData === 'string' && sigData.length > 100 && /^[A-Za-z0-9+/=]+$/.test(sigData)) {
                return (
                  <img 
                    src={`data:image/png;base64,${sigData}`} 
                    alt="Student Signature" 
                    style={{ maxHeight: 40, verticalAlign: 'middle' }} 
                  />
                );
              }
              
              // Check if it's a file path
              if (typeof sigData === 'string' && (sigData.includes('.png') || sigData.includes('.jpg') || sigData.includes('.jpeg'))) {
                return (
                  <img 
                    src={sigData} 
                    alt="Student Signature" 
                    style={{ maxHeight: 40, verticalAlign: 'middle' }} 
                  />
                );
              }
              
              // Return empty for incomplete or invalid data
              return null;
            })()}
          </span>
          <span style={{ minWidth: 40, fontFamily: 'sans-serif' }}>Date:</span>
          <span style={{ borderBottom: '1px solid #333', minWidth: 100, display: 'inline-block', padding: '0 4px', fontFamily: 'sans-serif' }}>{date}</span>
        </div>
      </div>
      <button
        className="print-hide"
        style={{ marginTop: 32, padding: '12px 32px', background: '#334293', color: 'white', border: 'none', borderRadius: 8, fontSize: '1.1rem', fontWeight: 600, cursor: 'pointer', display: 'block', marginLeft: 'auto', marginRight: 'auto' }}
        onClick={handleDownload}
      >
        Print Form
      </button>
    </div>
  );
};

export default ConsentReleaseInfoForm; 